import { FC } from 'react';
import { Skeleton } from './skeleton';

interface SkeletonRowsProps {
  count: number;
  colSpan: number;
  rowClassName?: string;
  cellClassName?: string;
  width?: string | number;
  height?: string | number;
  borderRadius?: string;
  className?: string;
}

export const SkeletonRows: FC<SkeletonRowsProps> = ({
  count,
  colSpan,
  rowClassName,
  cellClassName,
  ...skeletonProps
}) => (
  <>
    {Array.from({ length: count }).map((_, index) => (
      <tr key={index} className={rowClassName}>
        <td colSpan={colSpan} className={cellClassName}>
          <Skeleton {...skeletonProps} />
        </td>
      </tr>
    ))}
  </>
);
